import { useQuery } from 'react-query';
import { supabase } from '../lib/supabaseClient';

/**
 * A row of public.feature_flags, read straight from Supabase (authenticated
 * users can read the table). Fails closed: a missing row, a read error, or
 * the first render before the answer arrives all count as off.
 */
export function useFeatureFlag(key: string): boolean {
  const { data } = useQuery(
    ['feature_flag', key],
    async () => {
      const { data: row, error } = await supabase
        .from('feature_flags')
        .select('enabled')
        .eq('key', key)
        .maybeSingle();
      if (error) return false;
      return !!row?.enabled;
    },
    { staleTime: 5 * 60 * 1000, refetchOnWindowFocus: false },
  );
  return data === true;
}
